module.exports = __webpack_public_path__ + "img/Group 135.b7190943.svg";